import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import * as api from "../../../../api/apiCarros";
import useMediaQuery from "../../../hooks/useMediaQuery ";
import SectionZone from "../SectionZone";
import BannerDestaque from "./BannerDestaque";
import CoverflowSliderBlur from "./CoverflowSliderBlur";
import Prism from "./Prism";
import SliderNomal from "./SliderNomal";
import css from "./destaques.module.css";
import { ReactComponent as Mais } from "../../../../assets/icons/mais.svg";
import SoloDestaque from "./SoloDestaque";
import AuthContext from "../../../hooks/AuthContext";

export default function Destaques({
  infoJson,
  selectedItems,
  addToCompare,
  removeFromCompare,
  tipoDestaque,
  allinfoText,
  autoPlay,
  top,
}) {
  const ismobile = useMediaQuery("(max-width: 574px)");
  const isMobile = useMediaQuery("(min-width: 800px)");
  const isDesktop = useMediaQuery("(min-width: 992px)");
  const [ViaturasDestaques, setViaturasDestaques] = useState([]);
  const { state } = React.useContext(AuthContext);
  const [alltexto, setAlltexto] = useState({
    Titulo: "",
    SubTitulo: "",
    Zona: "",
    Url: "",
  });

  useEffect(() => {
    const fichaViatura = async () => {
      const viaturas = await api.getAllDestaques(tipoDestaque, infoJson);

      const motas = state.allMotas.filter(
        (item) => item.Destaque === true && item.Vendido === false
      );

      const barcos = state.allBarcos.filter(
        (item) => item.Destaque === true && item.Vendido === false
      );

      const vJuntas = viaturas
        .concat(motas)
        .concat(barcos)
        .sort(
          (a, b) => new Date(b.UltimaAlteracao) - new Date(a.UltimaAlteracao)
        );

      setViaturasDestaques(vJuntas);
    };
    fichaViatura();
  }, [infoJson, state, tipoDestaque]);

  useEffect(() => {
    allinfoText.Destaques && setAlltexto(allinfoText.Destaques);
  }, [allinfoText]);

  const renderSwitch = (param) => {
    switch (param) {
      case 5:
      case 1:
        return (
          <>
            {ismobile ? (
              <SliderNomal
                ViaturasDestaques={ViaturasDestaques}
                infoJson={infoJson}
                selectedItems={selectedItems}
                addToCompare={addToCompare}
                removeFromCompare={removeFromCompare}
              />
            ) : (
              <CoverflowSliderBlur
                ViaturasDestaques={ViaturasDestaques}
                infoJson={infoJson}
                selectedItems={selectedItems}
                addToCompare={addToCompare}
                removeFromCompare={removeFromCompare}
                autoPlay={autoPlay}
              />
            )}
          </>
        );
      case 2:
        return (
          <>
            {!isMobile ? (
              <SliderNomal
                ViaturasDestaques={ViaturasDestaques}
                infoJson={infoJson}
                selectedItems={selectedItems}
                addToCompare={addToCompare}
                removeFromCompare={removeFromCompare}
              />
            ) : (
              <Prism
                ViaturasDestaques={ViaturasDestaques}
                infoJson={infoJson}
                selectedItems={selectedItems}
                addToCompare={addToCompare}
                removeFromCompare={removeFromCompare}
              />
            )}
          </>
        );
      case 3:
        return (
          <>
            <BannerDestaque
              ViaturasDestaques={ViaturasDestaques}
              infoJson={infoJson}
              selectedItems={selectedItems}
              addToCompare={addToCompare}
              removeFromCompare={removeFromCompare}
              alltexto={alltexto}
              autoPlay={autoPlay}
            />
          </>
        );
      case 4:
        return (
          <>
            <SoloDestaque
              ViaturasDestaques={ViaturasDestaques}
              infoJson={infoJson}
              selectedItems={selectedItems}
              addToCompare={addToCompare}
              removeFromCompare={removeFromCompare}
              alltexto={alltexto}
              autoPlay={autoPlay}
            />
          </>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      {infoJson.Layout.Destaques.tipo === 3 ? (
        <>
          {ViaturasDestaques.length !== 0 && (
            <div
              className={`p-0 position-relative ${
                isDesktop
                  ? "container-fluid position"
                  : infoJson.Layout.Destaques.tipo === 3
                  ? "container-fluid position"
                  : "container-md"
              }`}
            >
              <>{renderSwitch(infoJson.Layout.Destaques.tipo)}</>
            </div>
          )}
        </>
      ) : (
        <>
          {ViaturasDestaques.length !== 0 && (
            <SectionZone
              Titulo={
                <>
                  {top && (
                    <>
                      {alltexto.Titulo !== ""
                        ? alltexto.Titulo
                        : "Viaturas em Destaque"}
                    </>
                  )}
                </>
              }
              SubTitulo={
                <>
                  {top && (
                    <>
                      {alltexto.SubTitulo !== ""
                        ? alltexto.SubTitulo
                        : "Sugerimos estas viaturas para si"}
                    </>
                  )}
                </>
              }
              top={!top && 10}
            >
              <div
                className={` position-relative ${
                  infoJson.Layout.Destaques.tipo === 4
                    ? `container-xxxl position ${css.noPaddingXs}`
                    : isDesktop
                    ? "p-0 container-fluid position"
                    : infoJson.Layout.Destaques.tipo === 3
                    ? "p-0 container-fluid position"
                    : "p-0 container-md"
                }`}
              >
                <>{renderSwitch(infoJson.Layout.Destaques.tipo)}</>

                {!infoJson.Layout.Carros.existe && (
                  <Link className={css.padding} to={"/viaturas/usadas/"}>
                    <Col
                      xs={12}
                      className={`d-flex justify-content-center mt-3`}
                    >
                      <button className={`btnPesquisa ${css.btnDireccoes}`}>
                        <Mais
                          height="18px"
                          width="18px"
                          stroke="#fff"
                          style={{ marginRight: "5px" }}
                        />
                        Ver Listagem Viaturas
                      </button>
                    </Col>
                  </Link>
                )}
              </div>
            </SectionZone>
          )}
        </>
      )}
    </>
  );
}
